import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter,
} from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { saveCcHpi, setCCHPIDefaults, setSegment } from '../store/ccHpi.actions'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import CcHpiContent from '../pageContent/ccHpi.content'
import { chevronBackOutline } from 'ionicons/icons'
import Diagnosis from '../../diagnosis/page/diagnosis.page'
import { getSituationSelector } from '../selectors'

const CcHpi: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const situationState = useSelector(getSituationSelector)
  const { segment, __areDefaultsSet } = situationState

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  const onSaveClick = () => {
    dispatch(saveCcHpi())
  }

  useIonViewDidEnter(() => {
    if (!__areDefaultsSet) {
      dispatch(setCCHPIDefaults(true))
    }
  }, [__areDefaultsSet])

  return (
    <IonPage id='CcHpiPage'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' onClick={onBackClick} color='primary-alt'>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton data-testid='Save' fill='clear' onClick={onSaveClick} color='primary-alt'>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
          <IonTitle>CC / HPI</IonTitle>
        </IonToolbar>
        <IonToolbar color='light'>
          <IonSegment
            color='dark'
            className='segment-bottom-padding'
            value={segment}
            onIonChange={(e) => dispatch(setSegment(e.detail.value || 'CCH'))}>
            <IonSegmentButton data-testid='CCHSegment' value={'CCH'}>
              <IonLabel>{t('ccHpi.CCH')}</IonLabel>
            </IonSegmentButton>

            <IonSegmentButton data-testid='DiagnosisSegment' value={'Diagnosis'}>
              <IonLabel>{t('diagnosis.ImpressionAndDiagnosis')}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>
      <IonContent color='light'>
        {segment === 'Diagnosis' && <Diagnosis />}

        {segment === 'CCH' && <CcHpiContent isPHI />}
      </IonContent>
    </IonPage>
  )
}

export default CcHpi
